
export default {

  RESET_CATEGORIES: function (state) {
    state.categories = {}
    state.openedCategorie = null
  },

  ADD_CATEGORIES : function (state, categories) {
    categories.forEach(function(cat){
      let categorie = state.categories[cat.id] || {products: []}
      categorie = {...categorie, ...cat}
      state.categories = { ...state.categories, ...{[cat.id]: categorie}}
    })
  },

  // Rechargement complet après un changement de stock : les catégories vides disparaissent.
  REPLACE_CATEGORIES: function (state, { categories, opened, openedProducts }) {
    if (opened && openedProducts) {
      categories[opened] = { ...categories[opened], products: openedProducts, loaded: true }
    }
    state.categories = categories
    state.openedCategorie = opened
  },

  ADD_PRODUCTS: function (state, {id, products}) {
    let categorie = state.categories[id] || {}
    categorie.products = products
    categorie.loaded = true
    state.categories = {...state.categories, ...{[id]: categorie}}
  },

  SET_OPENED_CATEGORIES: function (state, id) {
    state.openedCategorie = id
  },

  SET_LOADING: function (state, value) {
    state.loading = value
  },

  SET_LOADING_PRODUCTS: function (state, value) {
    state.loadingProducts = value
  },

  SET_CATEGORY_LOADED: function (state) {
    state.categoryLoaded = true
  },

  SET_SEARCH_RESULTS: function (state, results) {
    state.searchResults = results
  },

  SET_SEARCHING: function (state, value) {
    state.searching = value
  },

  SET_BUNDLES: function (state, bundles) {
    state.bundles = bundles
    state.bundlesLoaded = true
  },

  SET_LOADING_BUNDLES: function (state, value) {
    state.loadingBundles = value
  },

  SET_PACKS_MODE: function (state, value) {
    state.packsMode = value
  },

  CHANGE_PRODUCT_INFORMATIONS: function(state, response){
    let categorie = state.categories[response.category_id]
    if(categorie){
      categorie.products = categorie.products.map(pdt => {
        if(pdt.id == response.product_id){
          pdt.hasPromotion = response.hasPromotion
          pdt.price_ttc = response.price_ttc
          pdt.price_ttc_promo = response.price_ttc_promo
        }
        return pdt
      })
      state.categories = {...state.categories}
    }
  },

}
